/**
 * The one gate a group ID can't get you past: offline, on a device that has never loaded the
 * schedule, so there's nothing cached to show (§7).
 */
export default function OfflineFirstRun() {
  return (
    <div className="screen center">
      <div className="card">
        <h1>Topspin</h1>
        <p className="muted">
          You're offline and this device hasn't loaded the schedule yet. Try again on a
          connection.
        </p>
      </div>
    </div>
  );
}
